export const GT_RATING_PREFIX: string = 'RATING-';
export const GT_DEPARTURE_PREFIX: string = 'DEP-';
export const GT_DESTINATION_PREFIX: string = 'DST-';
export const GT_BOOKING_CODE_PREFIX: string = 'CODE-';
export const GT_CATEGORY_PREFIX: string = 'GT03-STAR/ST03-STAR';
export const GT_OUTBOUND_FLIGHT_TIMES_PREFIX: string = 'TIME-OUT-';
export const GT_INBOUND_FLIGHT_TIMES_PREFIX: string = 'TIME-IN-';



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/data/global-type-prefixes.ts